<template>
  <div>
    <div class="bg-provider-info mt-4 mb-4" v-if="$ml.get('temp_info')">
      {{ $ml.get('temp_info') }}
    </div>

    <div class="bg-provider-alert mt-4 mb-4" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <ObiForm v-if="state !== 'confirm' && !isLoading" @submit.prevent="doLogin">
      <div class="my-4">
        <ObiInput
          transparent
          type="email"
          name="email"
          :disabled="isLoading"
          v-model="formDataUsername.email"
          :label="$ml.get('email')"
          :placeholder="$ml.get('email')"
          :required="true"
        />
      </div>

      <div class="my-4" v-if="options && options.collect_phone">
        <ObiInput
          transparent
          type="text"
          name="phone"
          :disabled="isLoading"
          v-model="formDataUsername.phone"
          :label="$ml.get('phone')"
          :placeholder="$ml.get('phone')"
          :required="this.$props.options.phone_required"
        />
      </div>

      <div class="my-4" v-if="agreements && agreements.kvkk">
        <b-form-checkbox
          :value="true"
          :unchecked-value="false"
          v-model="kvkk_aggrement"
        >
          <small style="color: #848484;">
            <a href="#" @click="$emit('showAggrement')">
              {{ $ml.get('kvkk_policy_title') }}
            </a>
          </small>
        </b-form-checkbox>
      </div>
      <div class="my-4" v-if="false">
        <b-form-checkbox
          :value="true"
          :unchecked-value="false"
          v-model="general_aggrement"
        >
          <small style="color: #848484;">
            {{ $ml.get('general_policy_title') }}
          </small>
        </b-form-checkbox>
      </div>

      <div class="my-4">
        <ObiButton
          block
          :disabled="agreements && agreements.kvkk && !kvkk_aggrement"
          type="submit"
          :loading="isLoading"
          :text="$ml.get('connect_now')"
        />
      </div>
    </ObiForm>

    <ObiForm
      v-if="state === 'confirm' && !isLoading"
      @submit.prevent="confirmMailCode"
    >
      <div class="my-4">
        <ObiInput
          transparent
          type="number"
          name="code"
          :disabled="isLoading"
          v-model="formDataUsername.token"
          :label="$ml.get('email_code')"
          :placeholder="$ml.get('email_code')"
          required
        />
      </div>
      <div class="my-4">
        <ObiCol col="12">
          <ObiButton
            block
            type="submit"
            :loading="isLoading"
            :text="$ml.get('connect_now')"
          />
        </ObiCol>
      </div>
    </ObiForm>
    <ObiLoading v-else />
  </div>
</template>

<script>
import Notify from '@/libs/notify'
import ErrorHandler from '@/libs/error-handler'
import AuthApi from '@/api/AuthApi'
import AuthHandler from '@/libs/auth-handler'
import { get } from 'lodash'

import formDataUsername from '@/components/login-components/FormData/form-data-email'

export default {
  props: {
    options: {
      type: [Object],
    },
    rhid: {
      type: String,
      required: true,
    },
    agreements: {
      type: [Object],
    },
  },
  data() {
    return {
      slug: 'email',
      state: 'email',
      formDataUsername,
      isLoading: false,
      errorMessage: null,
      authData: null,
      days: [],
      months: [],
      years: [],
      kvkk_aggrement: false,
      general_aggrement: false,
    }
  },
  beforeMount() {
    this.setYears()
  },
  mounted() {
    if (
      this.$props.options &&
      this.$props.options.collect_email &&
      this.$props.options.email_required
    ) {
      this.formDataUsername._rules.email = 'required|email'
    }
    if (
      this.$props.options &&
      this.$props.options.collect_phone &&
      this.$props.options.phone_required
    ) {
      this.formDataUsername._rules.phone = 'required'
    }
  },
  methods: {
    setYears() {
      const startYear = 1930
      var lastYear = new Date().getFullYear()

      for (lastYear; lastYear >= startYear; lastYear--) {
        this.years.push({ label: lastYear, value: lastYear })
      }

      for (var day = 1; day <= 31; day++) {
        this.days.push({ label: day, value: day })
      }

      for (var month = 1; month <= 12; month++) {
        this.months.push({ label: month, value: month })
      }
    },
    async doLogin() {
      if (!this.formDataUsername.isValid({ disableDirtyCheck: true })) return

      this.isLoading = true

      try {
        const response = await AuthApi.auth(
          this.$props.rhid,
          this.slug,
          this.formDataUsername.toObject(),
        )

        if (response.data.success) {
          Notify.success(this.$ml.get('email_sent'))
          this.state = 'confirm'
          this.authData = response.data.data
        } else {
          ErrorHandler.handle(response.data)
        }
      } catch (err) {
        ErrorHandler.handle(err)
      } finally {
        this.isLoading = false

        this.$emit('end')
      }
    },
    async confirmMailCode() {
      if (!this.formDataUsername.isValid({ disableDirtyCheck: true })) return

      this.isLoading = true
      this.errorMessage = null

      try {
        const response = await AuthApi.confirmEmail(
          this.formDataUsername.toObject(),
        )

        if (response.data.success) {
          Notify.success(this.$ml.get('authorized'))
          AuthHandler.handle(this.authData)
        } else {
          //ErrorHandler.handle(response.data);
          const data = get(response, 'data') || get(response, 'response.data')
          this.errorMessage = get(data, 'message')
        }
      } catch (err) {
        //ErrorHandler.handle(err);
        const data = get(err, 'data') || get(err, 'response.data')
        this.errorMessage = get(data, 'message')
      } finally {
        this.isLoading = false

        this.$emit('end')
      }
    },
  },
}
</script>

<style scoped></style>
